import React, {useState, useRef} from "react";
import "./Teamsliderstyle.scss";
import TeamData from "./TeamData";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// import required modules
import { EffectCreative, FreeMode, Navigation, Thumbs } from 'swiper/modules';


const TeamThumbslider =()=> {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const prevRef = useRef(null);
        const nextRef = useRef(null);

    return(
        <>
            <section className="team-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center title">
                            <h2>What people have to say about us</h2>
                        </div>
                    </div>
                </div>

                <div className="container" style={{paddingTop:'10px'}}>
                    <div className="row">
                        <div className='col-12 col-lg-12 slider'>                                    
                            <div className='team-slider'>
                                
                                <Swiper
                                    style={{
                                    '--swiper-navigation-color': '#fff',
                                    '--swiper-pagination-color': '#fff',
                                    }}
                                    loop={true}
                                    spaceBetween={100}
                                    navigation={{
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current,
                                    }}
                                    onInit={(swiper) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                    }}
                                    centeredSlides={true}
                                    autoplay={{delay:4000,disableOnInteraction:false,pauseOnMouseEnter: false,}}  
                                    thumbs={{ swiper: thumbsSwiper }}
                                    modules={[FreeMode, Navigation, Thumbs, EffectCreative]}
                                    // grabCursor={true}
                                    // effect={'creative'}
                                    // creativeEffect={{
                                    // prev: {
                                    //     shadow: true,
                                    //     translate: ['-100%', 0, -500],
                                    // },
                                    // next: {
                                    //     translate: ['100%', 10, -500],
                                    // },     
                                    // speed: 800
                                    // }}
                                    className="mySwiper2"
                                >   
                                    
                                    {
                                        TeamData.map((obj)=>{
                                            return(

                                                <SwiperSlide> 
                                                    <div className="row" key={obj.id} style={{ textAlign:'center',position:'relative'}}>
                                                        <svg className="quote" width="136" height="109" viewBox="0 0 136 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M26.8837 0H53.0897L34.7907 52.3472H55.1229V109H0V57.5592L26.8837 0ZM107.761 0H133.967L115.668 52.3472H136V109H80.8771V57.5592L107.761 0Z" fill="white"/>
                                                        </svg>
                                                        <div className="col-12" style={{padding:'80px 10px', display:'flex', justifyContent:'center'}}>
                                                            <div style={{width:'55%'}}>
                                                                <h5 style={{color:'#157438'}}><b>Design Coordination</b></h5>
                                                                <p style={{opacity:'0.7',fontSize:'22px',color:'#000'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                                                <h6 style={{color:'#157438'}}><b>Dr. Laisram</b></h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }

                                    <div className="swipercustombtn">
                                        <button ref={prevRef} style={{  border: 'none', cursor: 'pointer',zIndex:'9' }}>                                        
                                            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.1201 0.707031L1.41422 7.41291L8.1201 14.1188" stroke="#157438" stroke-width="2"/>
                                            </svg>
                                        </button>
                                        <button ref={nextRef} style={{ border: 'none', cursor: 'pointer' }}>
                                            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.707108 0.707031L7.41299 7.41291L0.707108 14.1188" stroke="#157438" stroke-width="2"/>
                                            </svg>
                                        </button>
                                    </div>
                                </Swiper>
                                {/* <Swiper
                                    onSwiper={setThumbsSwiper}
                                    loop={true}
                                    spaceBetween={15}
                                    slidesPerView={4}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    className="mySwiper"
                                    slideToClickedSlide={true}
                                >
                                    {
                                        TeamData.map((obj)=>{
                                            return(
                                                <SwiperSlide> 
                                                    <div className="col-12" key={obj.id}>
                                                        <img src={obj.img} alt="" />
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }                                
                                </Swiper>                                 */}
                            </div>                    
                        </div>
                        
                    </div>
                </div>
            </section>
        </>
    )
}

export default TeamThumbslider;